import React from 'react';
import { useLanguage } from './LanguageContext';
import './ProductCard.css';

// Мы принимаем onCardClick
const ProductCard = ({ product, onCardClick }) => {
    const { t } = useLanguage();

    const {
        image,
        name,
        badgeText,
        title,
        features = [],
        prices = {},
        oldPrices = {},
        stockQuantity
    } = product;



    const handleCardClick = () => {
        // И, СУКА, ВЫЗЫВАЕМ ТОЖЕ onCardClick
        if (onCardClick) { // Добавляем проверку, чтобы не падало, если функцию не передали
            onCardClick(product);
        }
    };

    const formatOldPrice = (price) => {
        if (!price || price === 0) return '';
        return `${price.toLocaleString('ru-RU').replace(/\s/g, '\u00A0')}`; // Без валюты
    };

    const formatPrice = (price) => {
        if (!price || price === 0) return '';
        return `${price.toLocaleString('ru-RU').replace(/\s/g, '\u00A0')} тг`;
    };

    const calculateDiscount = (oldPrice, newPrice) => {
        if (!oldPrice || !newPrice || oldPrice == 0) return null;
        return Math.round(((oldPrice - newPrice) / oldPrice) * 100);
    };

    const featuresToDisplay = Array.isArray(features) ? features : [];

    return (
        <div className="showcase-card" onClick={handleCardClick}>
            <div className="showcase-image-container">
                {image ? <img src={image} alt={name} className="showcase-image" /> : <div className="showcase-placeholder">Нет фото</div>}

                {Object.entries(prices).length > 0 && Object.entries(oldPrices).length > 0 && (
                    (() => {
                        // Ищем максимальную скидку по всем размерам
                        let maxDiscount = -999999;
                        let hasDiscount = false;
                        Object.keys(prices).forEach(size => {
                            const discount = calculateDiscount(oldPrices[size], prices[size]);
                            if (discount !== null && discount > maxDiscount) {
                                maxDiscount = discount;
                                hasDiscount = true;
                            }
                        });
                        return hasDiscount ? <div className="showcase-discount-badge">-{maxDiscount}%</div> : null;
                    })()
                )}
            </div>

            <div className="showcase-content">
                {badgeText && <div className="showcase-badge">{badgeText}</div>}

                <h3 className="showcase-name">{name}</h3>
                <h3 className="showcase-name">{name || title}</h3>
                <ul className="showcase-features">
                    {featuresToDisplay.map((feature, index) => (
                        <li key={index}>{feature}</li>
                    ))}
                </ul>

                <div className="showcase-prices">
                    {Object.entries(prices)
                        .filter(([size, price]) => price > 0)
                        .sort(([sizeA], [sizeB]) => {
                            // Извлекаем первое число из размера (например, "90x200" -> 90, "200x200" -> 200)
                            const getFirstNumber = (sizeStr) => {
                                const match = sizeStr.toString().match(/^(\d+)/);
                                return match ? parseInt(match[1], 10) : 0;
                            };
                            return getFirstNumber(sizeA) - getFirstNumber(sizeB);
                        })
                        .map(([size, price]) => {
                            const oldPrice = oldPrices && oldPrices[size];
                            return (
                                <div key={size} className="showcase-price-item">
                                    {oldPrice && (
                                        <span className="showcase-price-old">{formatOldPrice(oldPrice)}</span>
                                    )}
                                    <span className="showcase-price-value">{formatPrice(price)}</span>
                                    <span className="showcase-price-label">
                                        *за размер{' '}
                                        <span className="price-size-dimension">{size}</span>
                                    </span>
                                </div>
                            );
                        })}
                </div>

                <button
                    className="showcase-button"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick();
                    }}
                >
                    {t('viewAndOrder')}
                </button>

                {stockQuantity > 0 && <p className="showcase-stock">Спешите! Осталось {stockQuantity} матрасов!</p>}
            </div>
        </div>
    );
};

export default ProductCard;